
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq/for-agents",
      function () {
        return require("private-next-pages/faq/for-agents.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/faq/for-agents"])
      });
    }
  